import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-modal-join-community',
  templateUrl: './modal-join-community.component.html',
  styleUrl: './modal-join-community.component.scss'
})
export class ModalJoinCommunityComponent {

  frmJoin: FormGroup = new FormGroup({
    message: new FormControl('', Validators.required)
  })

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private sanitizer: DomSanitizer,
  ) {}

  close() {
    this.ref.close();
  }

  save(){
    this.ref.close({frm: this.frmJoin.value})
  }

}
